import script from "./ThreadHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./ThreadHeader.vue?vue&type=script&setup=true&lang=ts"

import "./ThreadHeader.vue?vue&type=style&index=0&id=71d29aea&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71d29aea"]])

export default __exports__